import React, { useState, useEffect } from 'react';
import PLAYER from '../playerData';
import { ASSETS } from '../assetManifest';

const EMOJI_OPTIONS = [
  "🧑‍🚀", "👨‍🚀", "👩‍🚀", "🧑‍🔬", "👨‍🔬", "👩‍🔬", "🧑‍🌾", "👨‍🌾", "👩‍🌾",
  "🧑‍🏭", "👨‍🏭", "👩‍🏭", "🧑‍💼", "👨‍💼", "👩‍💼", "🧑‍🔧", "👨‍🔧", "👩‍🔧",
  "🧑‍🚒", "👨‍🚒", "👩‍🚒", "🧑‍⚕️", "👨‍⚕️", "👩‍⚕️", "🧑‍🎓", "👨‍🎓", "👩‍🎓"
];

function Profile({ app }) {
  const [name, setName] = useState(PLAYER.name);
  const [emoji, setEmoji] = useState(PLAYER.avatarEmoji);
  const [isEditing, setIsEditing] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  
  const handleSave = () => {
    PLAYER.name = name;
    PLAYER.avatarEmoji = emoji;
    setIsEditing(false);
    setShowEmojiPicker(false);
  };
  
  const handleCancel = () => {
    setName(PLAYER.name);
    setEmoji(PLAYER.avatarEmoji);
    setIsEditing(false);
    setShowEmojiPicker(false);
  };
  
  // Calculate current level (highest completed level + 1, or 1 if none completed)
  const currentLevel = PLAYER.completedLevels.length > 0 
    ? Math.max(...PLAYER.completedLevels) + 1 
    : 1;
  
  return (
    <div className="w-full h-full relative">
      <div className="w-full h-full relative">
        <img 
          src={ASSETS.backgrounds.profileBackground.path} 
          alt="Profile Background" 
          className="w-full h-full absolute left-0 top-0"
        />
        
        <div className="w-[183px] h-[46px] absolute left-[116px] top-[113px] text-center text-white text-2xl font-extrabold font-Asap uppercase leading-[14px]">
          PROFILE
        </div>
        
        <div className="absolute left-[122px] top-[157px] w-[170px] h-[170px] flex items-center justify-center">
          <img 
            src={ASSETS.ui.profileFrameOutline.path} 
            alt="Profile Frame" 
            className="w-[170px] h-[170px] absolute"
          />
          <div className="text-5xl z-10 relative">
            {emoji}
            {isEditing && (
              <button 
                className="absolute bottom-0 right-0 bg-blue-500 rounded-full p-1"
                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
              >
                ✏️
              </button>
            )}
          </div>
        </div>
        
        <div className="w-[282px] h-[47px] absolute left-[66px] top-[344px] bg-[#352a91]/60 rounded shadow-[inset_0px_1px_0px_0px_rgba(0,0,0,0.40)] shadow-[inset_0px_4px_4px_0px_rgba(0,0,0,0.25)] shadow-[inset_0px_0px_20px_4px_rgba(0,0,0,0.25)] flex items-center justify-center">
          {isEditing ? (
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="bg-transparent text-white text-2xl text-center py-2 px-4 w-full h-full outline-none font-extrabold font-Asap uppercase"
              maxLength={20}
            />
          ) : (
            <div className="text-center text-white text-2xl font-extrabold font-Asap uppercase leading-[14px]">
              {name}
            </div>
          )}
        </div>
        
        <div className="w-[223px] h-11 absolute left-[90px] top-[418px] bg-[#0a0342]/50 rounded shadow-[0px_2px_2px_0px_rgba(0,0,0,0.46)] flex items-center">
          <div className="w-[106px] h-[39px] absolute left-[32px] flex items-center justify-center text-center text-white text-sm font-extrabold font-Asap whitespace-nowrap">
            CURRENT LEVEL
          </div>
          <div className="w-[46px] h-14 absolute right-[10px] flex items-center justify-center text-center text-[#efbb57] text-[28px] font-extrabold font-Asap leading-[14px]">
            {currentLevel}
          </div>
        </div>
        
        {showEmojiPicker && (
          <div className="absolute left-1/2 -translate-x-1/2 top-[350px] bg-gray-800 p-4 rounded-lg mb-6 max-w-xs z-20">
            <div className="grid grid-cols-6 gap-2">
              {EMOJI_OPTIONS.map((e, index) => (
                <button
                  key={index}
                  className={`text-2xl p-2 rounded-lg ${emoji === e ? 'bg-blue-500' : 'hover:bg-gray-700'}`}
                  onClick={() => setEmoji(e)}
                >
                  {e}
                </button>
              ))}
            </div>
          </div>
        )}
        
        {isEditing ? (
          <div className="absolute left-0 top-[490px] flex w-full justify-center">
            <div className="w-[119px] h-[51px] absolute left-[69px] cursor-pointer" onClick={handleCancel}>
              <img 
                src={ASSETS.ui.buttonBackground.path} 
                alt="Cancel Button" 
                className="w-[119px] h-[51px] absolute left-0 top-0"
              />
              <div className="w-[108px] h-[23px] absolute left-[6px] top-0 bottom-0 flex items-center justify-center text-center text-white text-base font-extrabold font-Asap uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
                CANCEL
              </div>
            </div>
            
            <div className="w-[119px] h-[51px] absolute left-[202px] cursor-pointer" onClick={handleSave}>
              <img 
                src={ASSETS.ui.buttonBackground.path} 
                alt="Save Button" 
                className="w-[119px] h-[51px] absolute left-0 top-0"
              />
              <div className="w-[108px] h-[23px] absolute left-[6px] top-0 bottom-0 flex items-center justify-center text-center text-white text-base font-extrabold font-Asap uppercase [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
                SAVE
              </div>
            </div>
          </div>
        ) : (
          <div className="absolute w-[119px] h-[51px] left-1/2 -translate-x-1/2 top-[490px] cursor-pointer" onClick={() => setIsEditing(true)}>
            <img 
              src={ASSETS.ui.buttonBackground.path} 
              alt="Edit Profile Button" 
              className="w-[119px] h-[51px] absolute left-0 top-0"
            />
            <div className="w-[108px] h-[23px] absolute left-[6px] top-0 bottom-0 flex items-center justify-center text-center text-white text-base font-extrabold font-Asap uppercase whitespace-nowrap [text-shadow:_0px_4px_4px_rgb(0_0_0_/_0.25)]">
              EDIT PROFILE
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
